import {
  FETCH_REGION_ATTRIBUTES_REQUEST,
  FETCH_REGION_ATTRIBUTES_SUCCESS,
  FETCH_REGION_ATTRIBUTES_ERROR,
  UPDATE_REGION_ATTRIBUTES,
  SET_REGION_MARKET_LIST,
} from "./RegionTypes";

const initialState = {
  loading: false,
  error: null,
  RegionAttributesData: {}, // baseUrl: { item: {}, market: [] }
};

const RegionAttributesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REGION_ATTRIBUTES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_REGION_ATTRIBUTES_SUCCESS:
      return { ...state, loading: false, error: null };

    case FETCH_REGION_ATTRIBUTES_ERROR:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_REGION_ATTRIBUTES: {
      const { baseUrl, market, RegionAttributesData: data } = action;
      const prev = state.RegionAttributesData[baseUrl] || { item: {}, market: [] };

      return {
        ...state,
        RegionAttributesData: {
          ...state.RegionAttributesData,
          [baseUrl]: {
            item: {
              ...prev.item,
              [market]: data,
            },
            market: [...new Set([...prev.market, market])],
          },
        },
      };
    }
    case SET_REGION_MARKET_LIST: {
  const { baseUrl, marketList } = action;
  const prev = state.RegionAttributesData[baseUrl] || { item: {}, market: [] };

  return {
    ...state,
    RegionAttributesData: {
      ...state.RegionAttributesData,
      [baseUrl]: {
        ...prev,
        market: marketList, // ✅ Set sorted list
      },
    },
  };
}

    default:
      return state;
  }
};

export default RegionAttributesReducer;
